import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import usersObjectToQuery from '../../utils/usersObjectToQuery';
import statusObjectToQuery from '../../utils/statusObjectToQuery';
import equipmentsObjetctToQuery from '../../utils/equipmentsObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import { i18n } from '../../translate/i18n';
import axios from 'axios';
let CancelToken = axios.CancelToken;
let fetchActions_cancel;
let fetchActionsById_cancel;
let fetchActionsExport_cancel;
let fetchCompanies_cancel;

export const setActionsFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_ACTIONS_FILTER,
    actionsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const filterActionUsers = (users) => {
  return {
    type: actionTypes.FILTER_ACTION_USERS,
    users,
  };
};

export const filterActionUsersRemove = (user) => {
  return {
    type: actionTypes.FILTER_ACTION_USERS_REMOVE,
    user,
  };
};

export const filterActionUserStateRemove = () => {
  return {
    type: actionTypes.FILTER_ACTION_USERS_REMOVE_STATE,
  };
};

export const filterActionEquipments = (equipments) => {
  return {
    type: actionTypes.FILTER_ACTION_EQUIPMENTS,
    equipments,
  };
};

export const filterActionEquipmentsRemove = (equipment) => {
  return {
    type: actionTypes.FILTER_ACTION_EQUIPMENTS_REMOVE,
    equipment,
  };
};

export const filterActionPlaces = (places) => {
  return {
    type: actionTypes.FILTER_ACTION_PLACES,
    places,
  };
};

export const filterActionPlacesRemove = (place) => {
  return {
    type: actionTypes.FILTER_ACTION_PLACES_REMOVE,
    place,
  };
};

export const filterActionAreas = (areas) => {
  return {
    type: actionTypes.FILTER_ACTION_AREAS,
    areas,
  };
};

export const filterActionAreasRemove = (area) => {
  return {
    type: actionTypes.FILTER_ACTION_AREAS_REMOVE,
    area,
  };
};

export const filterActionStatus = (status) => {
  return {
    type: actionTypes.FILTER_ACTION_STATUS,
    status,
  };
};

export const filterActionStatusRemove = (status) => {
  return {
    type: actionTypes.FILTER_ACTION_STATUS_REMOVE,
    status,
  };
};

export const getUserAction = ({ name, id }) => {
  return {
    type: actionTypes.GET_USER,
    name,
    id
  }
}

export const filterActionStartDate = (startDate) => {
  return {
    type: actionTypes.FILTER_ACTION_START_DATE,
    startDate,
  };
};

export const filterActionStartDateRemove = (startDate) => {
  return {
    type: actionTypes.FILTER_ACTION_START_DATE_REMOVE,
    startDate,
  };
};

export const filterActionEndDate = (endDate) => {
  return {
    type: actionTypes.FILTER_ACTION_END_DATE,
    endDate,
  };
};

export const filterActionEndDateRemove = (endDate) => {
  return {
    type: actionTypes.FILTER_ACTION_END_DATE_REMOVE,
    endDate,
  };
};

export const filterActionClear = () => {
  return {
    type: actionTypes.FILTER_ACTION_CLEAR,
  };
};

export const fetchActionsSuccess = (actions) => {
  return {
    type: actionTypes.FETCH_ACTIONS_SUCCESS,
    actions: actions
  };
};

export const fetchActionByIdSuccess = (action) => {
  return {
    type: actionTypes.FETCH_ACTIONS_BY_ID_SUCCESS,
    action: action
  };
}

export const requestActionsFail = (error) => {
  return {
    type: actionTypes.REQUEST_ACTIONS_FAIL,
    error: error
  };
};

export const requestActionsStart = () => {
  return {
    type: actionTypes.REQUEST_ACTIONS_START
  };
};

export const deleteActionsSuccess = (action) => {
  return {
    type: actionTypes.DELETE_ACTIONS_SUCCESS,
    action: action
  }
}

export const checkDeleteActionsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_ACTIONS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateActionsSuccess = () => {
  return {
    type: actionTypes.UPDATE_ACTIONS_SUCCESS,
  }
}

export const postActionsSuccess = (action) => {
  return {
    type: actionTypes.POST_ACTIONS_SUCCESS,
    action: action
  }
}

export const fetchActions = (page, limit, search, order, orderBy, sites, filteredPlaces, filteredUsers, filteredStatus, filteredAreas, filteredCompanies, filteredStartDate, filteredEndDate, filteredEquipments) => {
  fetchActions_cancel && fetchActions_cancel();
  return dispatch => {
    dispatch(requestActionsStart());
    dispatch(setActionsFilter(page, limit, search, order, orderBy));
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
    queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
    queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${usersObjectToQuery(filteredUsers)}` : ''}`
    queryParams += `${filteredEquipments && filteredEquipments.length > 0 ? `&equipmentModel=${equipmentsObjetctToQuery(filteredEquipments)}` : ''}`
    queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`
    queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`
    queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${statusObjectToQuery(filteredStatus)}` : ''}`
    queryParams += `${filteredStartDate ? `&after=${filteredStartDate.toISOString()}` : ''}`
    queryParams += `${filteredEndDate ? `&before=${filteredEndDate.toISOString()}` : ''}`

    API.get('/actions' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchActions_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchActionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestActionsFail(err));
      });
  };
};

export const fetchActionsById = (id) => {
  fetchActionsById_cancel && fetchActionsById_cancel()
  return dispatch => {
    dispatch(requestActionsStart());
    API.get('/actions/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchActionsById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchActionByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestActionsFail(err));
      });
  };
};

export const deleteActions = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestActionsStart());
      API.put('/actions/' + index + '/delete')
        .then(res => {
          dispatch(deleteActionsSuccess(res.data));
          toastr.success(i18n.t('deleteActionsStore.toastrSuccess'), `${res.data.actionText} ${i18n.t('deleteActionsStore.toastrSuccess1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestActionsFail(err));
          if (err.response.data.error.message === "Not authorized (CreatedBy)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError1'))
          } 
          else if (err.response.data.error.message === "Not authorized (Accountable)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError2'))
          }
          else if (err.response.data.error.message === "Not authorized (withoutCreatedBy)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError3'))
          }
          else {
            toastr.error('Erro', err)
          }
          reject('error');
        });
    })

  }
}

export const checkDeleteActions = (index) => {
  return dispatch => {
    dispatch(requestActionsStart());
    API.get('/actions/' + index + '/checkdelete')
      .then(res => {
        console.log(res)
        dispatch(checkDeleteActionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestActionsFail(err));
      });
  }
}

export const postActions = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestActionsStart());
      API.post('/actions', body)
        .then((res) => {
          dispatch(postActionsSuccess({}));
          toastr.success(i18n.t('postActionsStore.toastr'), i18n.t('postActionsStore.toastr1'))
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestActionsFail(err));
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
}

export const updateActions = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestActionsStart());
      API.put('/actions/' + index, body)
        .then(res => {
          dispatch(updateActionsSuccess());
          toastr.success(i18n.t('updateActionsStore.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestActionsFail(err));
          if (err.response.data.error.message === "Not authorized (CreatedBy)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError1'))
          } 
          else if (err.response.data.error.message === "Not authorized (Accountable)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError2'))
          }
          else if (err.response.data.error.message === "Not authorized (withoutCreatedBy)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError3'))
          }
          else if (err.response.data.error.message === "Not authorized (Company)") {
            toastr.error(i18n.t('Erro'), i18n.t('updateActionsStore.toastrError3'))
          }
          else {
            toastr.error('Erro', err)
          }
          reject('error');
        });
    })
  }
}

export const addMessageTimelineAction = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestActionsStart());
      API.post('/actions/addmessage/' + index, body)
        .then(res => {
          dispatch(updateActionsSuccess(res.data));
          toastr.success(i18n.t('addMessageTimelineActionStr.toastr'))
          dispatch(fetchActionsById(index))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestActionsFail(err));
          toastr.error('Erro', err)
          reject('error');
        });
    })
  }
}

export const fetchActionsExport = (search, order, orderBy, sites, filteredPlaces, filteredUsers, filteredStatus, filteredAreas, filteredCompanies, filteredStartDate, filteredEndDate, filteredEquipments, emailLanguage) => {
  fetchActionsExport_cancel && fetchActionsExport_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${usersObjectToQuery(filteredUsers)}` : ''}`
      queryParams += `${filteredEquipments && filteredEquipments.length > 0 ? `&equipmentModel=${equipmentsObjetctToQuery(filteredEquipments)}` : ''}`
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${statusObjectToQuery(filteredStatus)}` : ''}`
      queryParams += `${filteredStartDate ? `&after=${filteredStartDate.toISOString()}` : ''}`
      queryParams += `${filteredEndDate ? `&before=${filteredEndDate.toISOString()}` : ''}`
      queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;

      API.get('/actions/report' + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchActionsExport_cancel = c;
        })
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          toastr.error('Erro', err)
          reject(err);
        });
    })
  };
};

const changeActionStatusStart = () => {
  return {
    type: actionTypes.ACTIONS_CHANGE_STATUS_START,
  }
}

const changeActionStatusSuccess = () => {
  return {
    type: actionTypes.ACTIONS_CHANGE_STATUS_SUCCESS,
  }
}

const changeActionStatusFail = () => {
  return {
    type: actionTypes.ACTIONS_CHANGE_STATUS_FAIL,
  }
}

export const changeActionStatus = (actionId, body) => {
  return dispatch => {
    dispatch(changeActionStatusStart());
    API.put(`actions/${actionId}/changestatus`, body)
      .then(res => {
        dispatch(changeActionStatusSuccess());
        toastr.success(i18n.t('updateActionsStore.toastr'));
        dispatch(fetchActionsById(actionId));
      })
      .catch(err => {
        dispatch(changeActionStatusFail());
        toastr.error('Erro', err)
      });
  }
};


export const addCompleteActionFile = (files) => {
  return {
    type: actionTypes.ACTIONS_ADD_COMPLETE_ACTION_FILE,
    files,
  }
}

export const editCompleteActionFile = (file, fileId) => {
  return {
    type: actionTypes.ACTIONS_EDIT_COMPLETE_ACTION_FILE,
    fileId,
    file,
  }
}

export const deleteCompleteActionFile = (fileId) => {
  return {
    type: actionTypes.ACTIONS_DELETE_COMPLETE_ACTION_FILE,
    fileId,
  }
}

export const clearCompleteActionFiles = () => {
  return {
    type: actionTypes.ACTIONS_CLEAR_COMPLETE_ACTION_FILES,
  }
}

const fetchCompaniesForFiltersStart = () => {
  return {
    type: actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_START,
  }
}

const fetchCompaniesForFiltersSuccess = (companies) => {
  return {
    type: actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_SUCCESS,
    payload: companies,
  }
}

const fetchCompaniesForFiltersFail = () => {
  return {
    type: actionTypes.ACTIONS_FETCH_COMPANIES_FOR_FILTERS_FAIL,
  }
}

export const actionsFetchCompaniesForFilters = (page, limit, search, order, orderBy) => {
  fetchCompanies_cancel && fetchCompanies_cancel()

  return dispatch => {
    dispatch(fetchCompaniesForFiltersStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/companies' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchCompanies_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchCompaniesForFiltersSuccess(res.data.rows));
      })
      .catch(err => {
        console.error(err)
        dispatch(fetchCompaniesForFiltersFail());
      });
  };
};

export const actionsfilterCompanies = (companies) => {
  return {
    type: actionTypes.FILTER_ACTION_COMPANIES,
    payload: companies,
  };
};

export const actionsfilterCompaniesRemove = (companyId) => {
  return {
    type: actionTypes.FILTER_ACTION_COMPANIES_REMOVE,
    payload: companyId,
  };
};
